import cn from "classnames";
import React from "react";

import { useOrgPrefixedPath } from "hooks/orgPaths";

import style from "./Breadcrumbs.module.scss";

import type { JSX } from "react";

type Breadcrumb = {
  // each breadcrumb must have a name
  name: string;
  // if not provided the breadcrumb can't be clicked
  linkTo?: string;
};

type Props = {
  path: Array<Breadcrumb>;
  className?: string;
};

// based on https://tailwindui.com/components/application-ui/navigation/breadcrumbs
export default function Breadcrumbs({ path, className }: Props): JSX.Element {
  const basePath = useOrgPrefixedPath("");
  return (
    <nav className={cn("flex", className)} aria-label="Breadcrumb">
      <ol className={cn("flex", style.list, style.noMargin)}>
        <li>
          <div>
            <a
              href={basePath}
              className={cn(
                "ml-4 text-sm font-medium text-legacyGray-500 hover:text-legacyGray-700",
                style.noMargin
              )}
            >
              Home
            </a>
          </div>
        </li>
        {path.map((page, idx) => (
          <li key={page.name}>
            <div className="flex items-center">
              <svg
                className="size-5 shrink-0 text-legacyGray-300"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a
                href={page.linkTo}
                className={cn(
                  "ml-4 text-sm font-medium text-legacyGray-500 hover:text-legacyGray-700",
                  style.noMargin
                )}
                aria-current={idx === path.length - 1 ? "page" : undefined}
              >
                {page.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
